module.exports = __webpack_public_path__ + "static/overview-whats-3@2x-21dd25ffe268ee0d1ec02c52577fa466.png";